<template>
    <div>
        <v-card class="item-translation-languages-dialog">
            <v-card-title>
                <span class="headline">{{ $t('front.item_translation_languages.modal_title') }}</span>
                <span class="close" @click="close">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L13 13" stroke="white" stroke-width="2"/>
                      <path d="M13 1L1 13" stroke="white" stroke-width="2"/>
                    </svg>
                </span>
            </v-card-title>

            <v-card-text>
                <h3>{{ $t('front.item_translation_languages.header') }}</h3>

                <p>{{ $t('front.item_translation_languages.available_translations') }}</p>

                <div class="item-translation-language" v-for="(allowedLocale, index) in allowedLocales" :key="index"
                     v-if="localeTitle(allowedLocale)" @click="changePageLocale(allowedLocale)">
                    <router-link :to="localeRoute(allowedLocale)">{{
                            localeTitle(allowedLocale)
                        }}
                    </router-link>
                </div>

            </v-card-text>
            <v-card-actions>
                <v-btn class="btn-success" @click="goToMainPage">{{ $t('front.item_translation_languages.to_main_page') }}</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import DisableBackgroundScroll from "../../mixins/disableBackgroundScroll";
import {defaultLanguage, publicAppLocales} from "../../../config/localization";
import {routesNames} from "../../interfaces/routeInterface";

export default {
    name: 'ItemTranslationLanguages',

    mixins: [DisableBackgroundScroll],

    computed: {
        allowedLocales() {
            return this.$store.state.translatedCurrentPageRoutes && this.$store.state.translatedCurrentPageRoutes.allowedLocales || [defaultLanguage];
        },

        currentPageRoute() {
            return this.$store.state.translatedCurrentPageRoutes && this.$store.state.translatedCurrentPageRoutes.route;
        },
    },

    methods: {
        localeTitle(allowedLocale) {
            let locale = publicAppLocales.find(locale => locale.name.toLowerCase() === allowedLocale);

            return locale && locale.title || '';
        },

        localeRoute(allowedLocale) {
            let locale = allowedLocale === defaultLanguage ? null : allowedLocale;

            let route = this.$router.resolve({
                name: this.currentPageRoute && this.currentPageRoute.name || routesNames.STATIC_PAGE,
                params: Object.assign(this.currentPageRoute && this.currentPageRoute.params || {slug: null}, {locale}),
                query: this.currentPageRoute && this.currentPageRoute.query,
                hash: this.currentPageRoute && this.currentPageRoute.hash,
            });

            return route.href;
        },

        changePageLocale(allowedLocale) {
            this.$store.commit('CLOSE_ITEM_TRANSLATION_LANGUAGES_DIALOG');

            let locale = allowedLocale === defaultLanguage ? null : allowedLocale;

            let redirectRoute = this.$router.resolve({
                name: this.currentPageRoute && this.currentPageRoute.name || routesNames.STATIC_PAGE,
                params: Object.assign(this.currentPageRoute && this.currentPageRoute.params || {slug: null}, {locale}),
                query: this.currentPageRoute && this.currentPageRoute.query,
                hash: this.currentPageRoute && this.currentPageRoute.hash,
            });

            this.$cookies.set('language', allowedLocale);
            this.$cookies.set('changeLanguage', allowedLocale);

            location.assign(location.origin + decodeURIComponent(redirectRoute.resolved.fullPath));
        },

        goToMainPage() {
            let locale = this.$store.state.locale;

            let redirectRoute = this.$router.resolve({
                name: routesNames.STATIC_PAGE,
                params: {locale: locale === defaultLanguage ? null : locale, slug: null,}
            });

            this.$cookies.set('language', locale);
            this.$cookies.set('changeLanguage', locale);

            this.$store.commit('CLOSE_ITEM_TRANSLATION_LANGUAGES_DIALOG');

            location.assign(location.origin + decodeURIComponent(redirectRoute.resolved.fullPath));
        },

        closeDialog() {
            this.$store.commit('CLOSE_ITEM_TRANSLATION_LANGUAGES_DIALOG');
        },

        close() {
            this.$store.commit('CLOSE_ITEM_TRANSLATION_LANGUAGES_DIALOG');

            this.goToMainPage();
        },
    }
}
</script>

<style lang="sass">
@import "sass/components/popups/ItemTranslationLanguages"
</style>